import { keikkaBetoni_cacheName, cache_read, cache_write } from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

export default class notkeusClass {
  constructor() {
    this.notkeusId = 0;
    this.notkeusSelite = "";
    this.notkeusSliderSortId = 0;
    this.notkeusText = "";
  }
  set(obj) {
    this.notkeusId = obj.notkeusId;
    this.notkeusSelite = obj.notkeusSelite;
    this.notkeusSliderSortId = obj.notkeusSliderSortId;
    this.notkeusText = obj.notkeusText;
  }
  get notkeusString() {
    var s = this.notkeusSelite;
    if (this.notkeusId === 10) {
      s = this.notkeusText || "S?";
    }
    return s;
  }
}

export async function betoniNotkeus_fetchList() {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/betoni/notkeus/list";
  const c = cache_read(keikkaBetoni_cacheName, fullUrl);
  if (c) return c;
  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "betoniNotkeusClass.js:fetchBetoniNotkeusList");
  if (!cResponse.success) return false;
  cache_write(keikkaBetoni_cacheName, fullUrl, cResponse.data, 0);
  return cResponse.data;
}
